import { useQuery, useQueryClient } from 'react-query'
import { useTimerStore } from '@/store/timerStore'
import { timeEntryService } from '@/services/timeEntryService'

export const ACTIVE_TIMER_QUERY_KEY = 'active-timer'

// Ask the server for the running timer again right away (e.g. after a 404 because the
// timer was already stopped from another tab or by an AI agent).
export const refreshActiveTimer = (queryClient) => queryClient.invalidateQueries(ACTIVE_TIMER_QUERY_KEY)

// Polls the server's running timer so the global TimerBar reflects timers started or
// stopped elsewhere (another tab, or Claude Code over MCP). Responses to requests that were
// sent before the latest local start/stop are ignored so they can't undo it.
export const useActiveTimerSync = (enabled) => {
  const queryClient = useQueryClient()

  useQuery(
    ACTIVE_TIMER_QUERY_KEY,
    async () => ({ requestedAt: Date.now(), res: await timeEntryService.getActive() }),
    {
      enabled: !!enabled,
      refetchInterval: 30 * 1000,
      refetchOnWindowFocus: true,
      onSuccess: ({ requestedAt, res }) => {
        const { activeTimer, localChangeAt, syncTimer } = useTimerStore.getState()
        if (requestedAt < (localChangeAt || 0)) return

        const serverTimer = res?.data?.activeTimer || null
        if ((activeTimer?.id ?? null) !== (serverTimer?.id ?? null)) {
          // Changed elsewhere: refresh views that show logged time
          queryClient.invalidateQueries('time-summary')
          const projectIds = new Set([activeTimer?.projectId, serverTimer?.task?.project_id].filter(Boolean))
          projectIds.forEach(id => queryClient.invalidateQueries(['projects', String(id), 'tasks']))
        }
        syncTimer(serverTimer)
      },
    }
  )
}
